import { useEffect, useState } from "react";
import { Submitbtn } from '../../../Component';
import DatePicker from '../../..//Component/datePicker';
import DropdownWithClear from '../../../Component/dropdownWithClear';
import LabelInput from '../../../Component/labelInput';
import PageTitle from '../../../module/pageTitle';
import moment from "moment";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import {
  getCategoryList,
  getProductList,
  getProductTypeList,
} from "../../Admin/adminSlice";
import { showSnackbar } from "../../../store/slices/snackbarSlice";
import { hideSnackbar } from "../../../store/slices/snackbarSlice";
import { getStockAnalysis } from "../cxoSlice";
import { getSellingSourceList } from "../../../Screen/Publication/publicationSlice";
const StockAnalysis = () => {
  const dispatch: Function = useDispatch<AppDispatch>();
  const [productTypeList, setProductTypeList] = useState<any>([]);
  const [productType, setProductType] = useState<any>("");
  const [category, setCategory] = useState<any>("");
  const [categoryList, setCategoryList] = useState<any>([]);
  const [sellingSrcData, setSellingSrcData] = useState<{ _id: string; name: string; price: string; isChecked: boolean }[]>([]);
  const [startDate, setStartDate] = useState<any>(
    moment.utc(new Date()).format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState<any>(
    moment.utc(new Date()).format("YYYY-MM-DD")
  );
  const [stockAnalysisList, setStockAnalysisList] = useState<any>([]);
  useEffect(() => {
    dispatch(
      getProductTypeList({
        callback: (res: any) => {
          setProductTypeList(res?.data);
        },
        errorCallback: () => { },
      })
    );

    dispatch(
      getSellingSourceList({
        callback: (res: any) => {
          if (res?.data?.length > 0) {
            const newArr = res?.data?.map((item: any) => {
              return {
                _id: item?._id,
                name: item?.name,
                price: "",
                isChecked: false,
              };
            });
            setSellingSrcData(newArr);
          }

        },
        errorCallback: () => { },
      })
    );

  }, []);

  const onchangeStartDate = (value: any) => {
    setStartDate(value);
  };
  const onchangeEndDate = (value: any) => {
    setEndDate(value);
  };
  const onchangeProductType = (value: any) => {
    setProductType(value);
    const postData = {
      productTypeId: value?._id,
    };
    dispatch(
      getCategoryList({
        params: postData,
        callback: (res: any) => {
          setCategoryList(res);
        },
        errorCallback: (error: any) => { },
      })
    );
  };
  const onchangeCategory = (value: any) => {
    setCategory(value);

  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const postData = {
      startDate: startDate,
      endDate: endDate,
      productTypeId: productType?._id,
      productCategoryId: category?._id,

    };
    dispatch(
      getStockAnalysis({
        params: postData,
        callback: (res: any) => {
          setStockAnalysisList(res?.data);
          dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }));
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        },
      })
    );
  };
  const renderTable = () => {
    return (
      <div className="table-responsive">
        <table className="table table-striped table-hover align-middle text-md-start text-center">
          <thead>
            <tr>
              <th rowSpan={3} className="border border-gray-400 px-4 py-2 text-center">
                Sr. No.
              </th>
              <th rowSpan={3} className="border border-gray-400 px-4 py-2 text-center">
                BOOK NAME
              </th>
              <th colSpan={sellingSrcData?.length + 2} className="border border-gray-400 px-4 py-2 text-center">
                TWO BROTHERS IN HOUSE
              </th>
              <th colSpan={sellingSrcData?.length + 2} className="border border-gray-400 px-4 py-2 text-center">
                TWO BROTHERS WAREHOUSE
              </th>
              <th colSpan={sellingSrcData?.length * 3} className="border border-gray-400 px-4 py-2 text-center">
                PUBLICATION IN HOUSE
              </th>
              <th colSpan={sellingSrcData?.length * 3} className="border border-gray-400 px-4 py-2 text-center">
                PUBLICATION WAREHOUSE
              </th>
              <th className="border border-gray-400 px-4 py-2 text-center">
                DAMAGE IN HOUSE
              </th>
            </tr>
            <tr>
              <th rowSpan={2} className="border border-gray-400 px-4 py-2 text-center">
                IN
              </th>
              {sellingSrcData?.sort((a, b) => a.name.localeCompare(b.name))?.map((item, index) => {
                return (
                  <th
                    key={index}
                    className="border border-gray-400 px-4 py-2 text-center"
                  >
                    {item?.name}
                  </th>
                );
              })
              }
              <th
                rowSpan={2}
                className="border border-gray-400 px-4 py-2 text-center"
              >
                Current
              </th>
              <th
                rowSpan={2}
                className="border border-gray-400 px-4 py-2 text-center"
              >
                IN
              </th>
              {sellingSrcData?.sort((a, b) => a.name.localeCompare(b.name))?.map((item, index) => {
                return (
                  <th
                    key={index}
                    // colSpan={wareHouseNamesColSpan(item)}
                    className="border border-gray-400 px-4 py-2 text-center"
                  >
                    {item?.name}
                  </th>
                );
              })
              }
              <th
                rowSpan={2}
                className="border border-gray-400 px-4 py-2 text-center"
              >
                Current
              </th>
              {sellingSrcData?.sort((a, b) => a.name.localeCompare(b.name))?.map((item, index) => {
                return (
                  <th
                    key={index}
                    colSpan={3}
                    className="border border-gray-400 px-4 py-2 text-center"
                  >
                    {item?.name}
                  </th>
                );
              })}

              {sellingSrcData?.sort((a, b) => a.name.localeCompare(b.name))?.map((item, index) => {
                return (
                  <th
                    key={index}
                    colSpan={3}
                    className="border border-gray-400 px-4 py-2 text-center"
                  >
                    {item?.name}
                  </th>
                );
              })}

              <th
                rowSpan={2}
                className="border border-gray-400 px-4 py-2 text-center"
              >
                IN
              </th>
            </tr>
            <tr>
              {sellingSrcData?.sort((a: any, b: any) => a.name.localeCompare(b.name))?.map((item: any, index: any) => {
                return (
                  <th className="border border-gray-400 px-4 py-2 text-center">
                    OUT
                  </th>
                );
              })}
              {sellingSrcData?.sort((a: any, b: any) => a.name.localeCompare(b.name))?.map((item: any, index: any) => {
                return (
                  <th className="border border-gray-400 px-4 py-2 text-center">
                    OUT
                  </th>
                );
              })}
              {sellingSrcData?.sort((a: any, b: any) => a.name.localeCompare(b.name))?.map((item: any, index: any) => {
                return (
                  <>
                    <th className="border border-gray-400 px-4 py-2 text-center">IN</th>
                    <th className="border border-gray-400 px-4 py-2 text-center">
                      OUT
                    </th>
                    <th className="border border-gray-400 px-4 py-2 text-center">
                      CURRENT
                    </th>
                  </>
                );
              })}
              {sellingSrcData?.sort((a: any, b: any) => a.name.localeCompare(b.name))?.map((item: any, index: any) => {
                return (
                  <>
                    <th className="border border-gray-400 px-4 py-2 text-center">IN</th>
                    <th className="border border-gray-400 px-4 py-2 text-center">
                      OUT
                    </th>
                    <th className="border border-gray-400 px-4 py-2 text-center">
                      CURRENT
                    </th>
                  </>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {stockAnalysisList?.map((mainItem: any, mainIndex: any) => (
              <tr key={mainIndex}>
                <td className="border border-gray-400 px-4 py-2 text-center">
                  {mainIndex + 1}
                </td>
                <td className="border border-gray-400 px-4 py-2 text-center">
                  {mainItem?.bookName}
                </td>
                {mainItem?.locations?.map((item: any, index: any) => {
                  if (index < 2) {
                    return (
                      <>
                        <td className="border border-gray-400 px-4 py-2 text-center">
                          {item?.in}
                        </td>
                        {item?.sources?.sort((a: any, b: any) => a.name.localeCompare(b.name))?.map((sourcesitem: any) => (
                          <td className="border border-gray-400 px-4 py-2 text-center">
                            {sourcesitem?.out}
                          </td>
                        ))}
                        <td className="border border-gray-400 px-4 py-2 text-center">
                          {item?.current}
                        </td>
                      </>
                    )
                  }
                  else if (index >= 2 && index < 4) {
                    return (
                      item?.sources?.sort((a: any, b: any) => a.name.localeCompare(b.name))?.map((sourcesitem: any, srcindex: any) => (
                        <>
                          <td className="border border-gray-400 px-4 py-2 text-center">
                            {sourcesitem?.in}
                          </td>
                          <td className="border border-gray-400 px-4 py-2 text-center">
                            {sourcesitem?.out}
                          </td>
                          <td className="border border-gray-400 px-4 py-2 text-center">
                            {sourcesitem?.current}
                          </td></>
                      ))
                    )
                  }
                  else {
                    return (
                      <td className="border border-gray-400 px-4 py-2 text-center">
                        {item?.in}
                      </td>
                    )
                  }
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle name={"STOCK ANALYSIS"} />
      </div>
      <div className="formDiv">
        <div className="bxshadow p-2 borderRadius mb-4 ">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-3 mb-3 p-2">
                <LabelInput labelName={"Start Date"} isRequired />
                <DatePicker
                  setInputText={(value: any) => {
                    onchangeStartDate(value);
                  }}
                  value={startDate}
                />
              </div>
              <div className="col-md-3 mb-3 p-2">
                <LabelInput labelName={"End Date"} isRequired />
                <DatePicker
                  setInputText={(value: any) => {
                    onchangeEndDate(value);
                  }}
                  value={endDate}
                />
              </div>
              <div className="col-md-3 mb-3 p-2">
                <LabelInput labelName={"Product Type"} />
                <DropdownWithClear
                  labelName={"Select Product Type"}
                  setInputText={(value: any) => onchangeProductType(value)}
                  options={productTypeList}
                  value={productType}
                />
              </div>
              <div className="col-md-3 mb-3 p-2">
                <LabelInput labelName={"Category"} />
                <DropdownWithClear
                  labelName={"Select Product category "}
                  setInputText={(value: any) => onchangeCategory(value)}
                  options={categoryList}
                  value={category}
                />
              </div>
            </div>
            <div className="col-md-2 mx-auto mt-3">
              <Submitbtn name={"Submit"} />
            </div>
          </form>
        </div>
        <div className="bxshadow p-2 borderRadius mb-4" style={{ maxWidth: "1200px" }}>
          {renderTable()}
        </div>
      </div>
    </div>
  );
}

export default StockAnalysis;